import { render, staticRenderFns } from "./MoveOneTimeTransactionToSaving.vue?vue&type=template&id=02c54000&scoped=true"
import script from "./MoveOneTimeTransactionToSaving.vue?vue&type=script&lang=js"
export * from "./MoveOneTimeTransactionToSaving.vue?vue&type=script&lang=js"
import style0 from "./MoveOneTimeTransactionToSaving.vue?vue&type=style&index=0&id=02c54000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c54000",
  null
  
)

export default component.exports